import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useAlert } from 'contexts/AlertContext';
// import { validateStorageToken } from './common';
import { palette } from 'pages/AnyfitMall/theme';
import { API_BASE_URL } from 'pages/AnyfitMall/config';

const CancelBtn = styled.button`
  font-size: 0.75rem;
  color: ${palette.Red400};
  min-width: 60px;
  width: auto;
  padding: 0.4rem 0.8rem;
  border: 1px solid ${palette.Red400};
  border-radius: 4px;
  background: white;
  height: auto;

  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;

  &:hover:not(:disabled) {
    color: ${palette.Red500};
    cursor: pointer;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const OrderCancelButton = ({ orderId, token, fetchOrders, children }) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    console.log('token...', token);
  }, []);
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const cancelOrder = async (token, orderId) => {
    setIsLoading(true);
    try {
      // 토큰 출력
      console.log('token...', token);
      const response = await fetch(`${API_BASE_URL}/api/cancelOrder`, {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ orderId: orderId }),
      });

      if (response.ok) {
        const data = await response.json();
        console.log('data...', data);
        showAlert('주문이 취소됐습니다.');
        // fetchOrders();
        window.location.reload();
      } else {
        console.error('Failed to fetch products:', response.statusText);
        showAlert('토큰이 유효하지 않습니다.');
        navigate('/anyfit/error');
      }
    } catch (error) {
      console.error('주문 취소 에러:', error);
      showAlert('주문 취소 중 오류가 발생했습니다.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <CancelBtn onClick={() => cancelOrder(token, orderId)} disabled={isLoading}>
      {isLoading ? '주문 취소 중...' : children}
    </CancelBtn>
  );
};

export default OrderCancelButton;
